import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api.js'
import { useAuth } from '../services/auth.jsx'

const ROLE_CFG = {
  admin:    { label: 'Admin',    color: '#fbbf24', bg: '#451a03' },
  operator: { label: 'Operador', color: '#86efac', bg: '#052e16' },
  owner:    { label: 'Owner',    color: '#93c5fd', bg: '#1e3a5f' },
}

export default function UsersPage() {
  const { user: currentUser, currentFazenda } = useAuth()
  const [users, setUsers] = useState([])
  const [fazendas, setFazendas] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [editingUser, setEditingUser] = useState(null)     // user obj para edição
  const [changingPwdId, setChangingPwdId] = useState(null)

  async function fetchUsers() {
    try {
      const data = await api.getUsers(currentFazenda?.id)
      setUsers(data)
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    api.getFazendas().then(setFazendas).catch(() => {})
  }, [])

  useEffect(() => { fetchUsers() }, [])

  async function handleDelete(user) {
    if (!window.confirm(`Excluir usuário "${user.username}"?`)) return
    try {
      await api.deleteUser(user.id)
      await fetchUsers()
    } catch (e) {
      setError(e.message)
    }
  }

  async function handleToggleActive(user) {
    try {
      await api.updateUser(user.id, { active: !user.active })
      await fetchUsers()
    } catch (e) {
      setError(e.message)
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f0fdf4' }}>
      {/* Header */}
      <div style={{ background: '#14532d', padding: '0 24px', height: 60, display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ color: '#86efac', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>← Dashboard</Link>
        <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
        <span style={{ fontSize: 26 }}>🌾</span>
        <div style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>Gerenciar Usuários</div>
        <button onClick={() => { setEditingUser(null); setShowForm(true) }} style={{
          marginLeft: 'auto', background: '#16a34a', color: '#fff', border: 'none',
          borderRadius: 10, padding: '8px 16px', cursor: 'pointer', fontWeight: 700, fontSize: 13,
        }}>
          ➕ Novo Usuário
        </button>
      </div>

      <div style={{ maxWidth: 640, margin: '32px auto', padding: '0 16px' }}>
        {error && (
          <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '12px 16px', borderRadius: 10, fontWeight: 600, fontSize: 13, marginBottom: 16 }}>
            Erro: {error}
            <button onClick={() => setError('')} style={{ marginLeft: 12, background: 'none', border: 'none', cursor: 'pointer', color: '#7f1d1d', fontWeight: 800 }}>×</button>
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: 40 }}>Carregando...</div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
            {users.map((user, idx) => {
              const isMe = user.username === currentUser?.username
              const role = ROLE_CFG[user.role] ?? ROLE_CFG.operator
              return (
                <div key={user.id} style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px',
                  borderBottom: idx < users.length - 1 ? '1px solid #e7f3ea' : 'none',
                  background: user.active ? '#fff' : '#f8fafc',
                }}>
                  {/* Avatar */}
                  <div style={{
                    width: 38, height: 38, borderRadius: 999, flexShrink: 0,
                    background: role.bg, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 16, fontWeight: 800, color: role.color,
                  }}>
                    {user.username[0].toUpperCase()}
                  </div>

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontWeight: 700, color: user.active ? '#0f172a' : '#94a3b8', fontSize: 14 }}>
                        {user.username}
                      </span>
                      {isMe && <span style={{ fontSize: 10, background: '#f0fdf4', color: '#16a34a', border: '1px solid #86efac', borderRadius: 999, padding: '1px 7px', fontWeight: 700 }}>você</span>}
                      {!user.active && <span style={{ fontSize: 10, background: '#f1f5f9', color: '#94a3b8', borderRadius: 999, padding: '1px 7px', fontWeight: 700 }}>inativo</span>}
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: '1px 8px', borderRadius: 999, background: role.bg, color: role.color }}>
                      {role.label}
                    </span>
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                    <button
                      onClick={() => setChangingPwdId(changingPwdId === user.id ? null : user.id)}
                      style={actionBtn('#f1f5f9', '#475569')}
                      title="Alterar senha"
                    >🔑</button>
                    <button
                      onClick={() => handleToggleActive(user)}
                      disabled={isMe}
                      style={actionBtn(user.active ? '#fef9c3' : '#dcfce7', user.active ? '#713f12' : '#15803d')}
                      title={user.active ? 'Desativar' : 'Ativar'}
                    >
                      {user.active ? '⏸' : '▶'}
                    </button>
                    <button
                      onClick={() => handleDelete(user)}
                      disabled={isMe}
                      style={actionBtn('#fee2e2', '#b91c1c')}
                      title="Excluir"
                    >🗑</button>
                  </div>
                </div>
              )
            })}

            {/* Inline password change form */}
            {changingPwdId && (
              <ChangePasswordForm
                userId={changingPwdId}
                onDone={() => setChangingPwdId(null)}
                onError={setError}
              />
            )}
          </div>
        )}
      </div>

      {/* New/Edit user modal */}
      {showForm && (
        <UserFormModal
          fazendas={fazendas}
          defaultFazendaId={currentFazenda?.id ?? null}
          onSave={async (data) => {
            await api.createUser(data)
            await fetchUsers()
            setShowForm(false)
          }}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  )
}

// ── ChangePasswordForm ────────────────────────────────────────────────────────
function ChangePasswordForm({ userId, onDone, onError }) {
  const [pwd, setPwd] = useState('')
  const [saving, setSaving] = useState(false)

  async function save() {
    if (!pwd.trim()) return
    setSaving(true)
    try {
      await api.updateUser(userId, { password: pwd })
      onDone()
    } catch (e) {
      onError(e.message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{ padding: '12px 20px', borderTop: '1px solid #e7f3ea', background: '#f8fdf9', display: 'flex', gap: 8, alignItems: 'center' }}>
      <span style={{ fontSize: 13, color: '#475569', fontWeight: 600, whiteSpace: 'nowrap' }}>Nova senha:</span>
      <input
        type="password"
        value={pwd}
        onChange={e => setPwd(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') onDone() }}
        style={{ flex: 1, padding: '7px 12px', borderRadius: 8, border: '1.5px solid #86efac', fontSize: 14, outline: 'none' }}
        placeholder="Mínimo 4 caracteres"
        autoFocus
      />
      <button onClick={save} disabled={saving || !pwd.trim()} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', cursor: 'pointer', fontWeight: 700, fontSize: 13 }}>
        {saving ? '...' : 'Salvar'}
      </button>
      <button onClick={onDone} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, padding: '7px 12px', cursor: 'pointer', fontSize: 13 }}>✕</button>
    </div>
  )
}

// ── UserFormModal ─────────────────────────────────────────────────────────────
function UserFormModal({ onSave, onClose, fazendas, defaultFazendaId }) {
  const [form, setForm] = useState({ username: '', password: '', role: 'operator', fazenda_id: defaultFazendaId ?? '' })
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })) }

  const needsFazenda = form.role !== 'admin'

  async function handleSave() {
    if (!form.username.trim()) return setError('Nome de usuário é obrigatório')
    if (!form.password.trim()) return setError('Senha é obrigatória')
    if (needsFazenda && !form.fazenda_id) return setError('Selecione a fazenda para este usuário')
    setSaving(true)
    setError('')
    try {
      await onSave({
        username: form.username.trim(),
        password: form.password,
        role: form.role,
        fazenda_id: needsFazenda ? Number(form.fazenda_id) : null,
      })
    } catch (e) {
      setError(e.message)
      setSaving(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: '#14532d', borderRadius: 16, padding: '28px 32px', maxWidth: 380, width: '100%', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 11, color: '#86efac', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 }}>Novo Usuário</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 20 }}>➕ Adicionar acesso</div>

        <label style={lbl}>Nome de usuário *</label>
        <input value={form.username} onChange={set('username')} style={inp} placeholder="Ex: joao.silva" autoFocus />

        <label style={{ ...lbl, marginTop: 12 }}>Senha *</label>
        <input type="password" value={form.password} onChange={set('password')} style={inp} placeholder="Mínimo 4 caracteres" />

        <label style={{ ...lbl, marginTop: 12 }}>Perfil *</label>
        <select value={form.role} onChange={set('role')} style={{ ...inp, cursor: 'pointer' }}>
          <option value="operator">Operador (campo)</option>
          <option value="owner">Owner (proprietário)</option>
          <option value="admin">Admin (gerência)</option>
        </select>

        {needsFazenda && (
          <>
            <label style={{ ...lbl, marginTop: 12 }}>Fazenda *</label>
            <select value={form.fazenda_id} onChange={set('fazenda_id')} style={{ ...inp, cursor: 'pointer' }}>
              <option value="">— selecione —</option>
              {fazendas.map(f => (
                <option key={f.id} value={f.id}>{f.name}</option>
              ))}
            </select>
          </>
        )}

        {error && <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginTop: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={onClose} disabled={saving} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Cancelar</button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            {saving ? 'Criando...' : 'Criar usuário'}
          </button>
        </div>
      </div>
    </div>
  )
}

const lbl = { display: 'block', fontSize: 10, fontWeight: 700, color: '#86efac', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 4 }
const inp = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #16a34a', background: '#052e16', color: '#fff', fontSize: 14, boxSizing: 'border-box', outline: 'none' }

function actionBtn(bg, color) {
  return { background: bg, border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 15, color, lineHeight: 1 }
}
